module.exports = __webpack_public_path__ + "media/images/img-bernard-4ba3fe0202164ed23cbe405949cd64d4.png";